export default theme => ({
  player: {
    width: "100%",
    maxWidth: 720,
    marginTop: 30,
    margin: "auto",
  },
  player_internal: {
    width: "100%",
  },
});
